export const config = {
  rowSelectionType: 'radio',
  fieldControl: false,
  scroll: {y: 350},
  columns: [
    {
      title: '员工姓名',
      dataIndex: 'userName',
      width: 150,
      ellipsis: true,
    },
    {
      title: '员工工号',
      dataIndex: 'loginAccount',
      width: 120
    },
    {
      title: '所属组织',
      dataIndex: 'orgNamePath',
      width: 180,
      ellipsis: true,
    },
    {
      title: '职位',
      dataIndex: 'roleName',
      width: 150,
      ellipsis: true,
    },
  ],
  search: [
    {
      name: 'userNameKeyword',
      label: '员工姓名',
    },
    {
      label: '角色',
      name: 'roleId',
      itemType: 'select',
      data: 'roleList',
      labelKey: 'name',
      key: 'id',
    }
  ]
}